<template>
    <InputGroup v-if="!fnT.data[fnT.active].payload.cardId">
        <AutoComplete
            id="searchCustomer"
            :loading="false"
            v-model="fnT.data[fnT.active].Customer"
            @complete="search"
            @item-select="getCrime(fnT.data[fnT.active].Customer)"
            :suggestions="Customers"
            scrollHeight="500px"
            placeholder="Tìm kiếm khách hàng (F4)"
            @before-show="Fnscroll"
        >
            <template #empty>
                <div class="text-center align-items-center flex flex-column p-4">
                    <span>Không tìm thấy khách hàng tương ứng</span>
                </div>
            </template>
            <template #option="slotProps">
                <div @click="chooseCustomer" class="flex align-items-center justify-content-between">
                    <div class="flex align-items-center gap-3">
                        <img class="w-3rem h-3rem border-circle" :src="slotProps?.option?.avatar || '/demo/images/avatar/user.png'" />
                        <div>
                            <div class="font-semibold">
                                {{ slotProps?.option?.cardName || '' }}
                            </div>
                            <div class="text-base text-gray-700 mt-2">
                                {{ slotProps?.option?.BPCode || '' }}
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <template #footer>
                <!-- <Paginator
          :rows="10"
          :totalRecords="120"
          :rowsPerPageOptions="[10, 20, 30]"
        ></Paginator> -->
            </template>
        </AutoComplete>
        <InputGroupAddon @click="addNewCustomerDialog()">
            <i class="pi pi-plus"></i>
        </InputGroupAddon>
    </InputGroup>
    <ButtonGroup v-if="fnT.data[fnT.active].payload.cardId" class="flex">
        <Button severity="secondary" icon="pi pi-user" />
        <Button class="w-full" @click="openUpdVendorDialog(fnT.data[fnT.active].payload.cardId)" severity="secondary" :label="`${fnT.data[fnT.active].payload.cardName}`"></Button>
        <Button @click="Remove()" severity="secondary" icon="pi pi-times" />
    </ButtonGroup>
    <div v-if="fnT.data[fnT.active].payload.cardId">
        <div class="flex align-items-center justify-content-between gap-2">
            <div class="flex align-items-center flex-wrap gap-2">
                <strong class="text-gray-700">Địa chỉ</strong>
                <Tag value="Mặc định" />
                <Tag v-if="fnT.data?.[fnT.active]?.payload?.isInvestor" severity="danger" value="Khách đầu tư" />
            </div>
            <Button label="Thay đổi" size="small" text class="p-0" @click="openUpdVendorDialog(fnT.data[fnT.active].payload.cardId)" />
        </div>

        <div class="card mt-2 bg-teal-50 p-3">
            <div class="flex flex-column gap-2">
                <div class="flex flex-column gap-1">
                    <span class="text-gray-700"><b>Số điện thoại:</b> {{ fnT.data[fnT.active].payload.address?.phone || '' }}</span>
                    <span class="text-gray-700"><b>Email:</b> {{ fnT.data[fnT.active].payload.address?.email || '' }}</span>
                    <span class="text-gray-700"><b>Địa chỉ:</b> {{ getAddress(fnT.data[fnT.active].payload.address) || '' }}</span>
                </div>
            </div>
        </div>
    </div>
    <dialogCustomer :visible="uptCustomerModal" @visible="closeDialogCustomer($event)" :detailCustomer="fnT.data[fnT.active].Customer" @update:data="updateCustome($event)"></dialogCustomer>

    <Dialog v-model:visible="visibleCrime" modal header="Danh sách đối tượng truy nã" :style="{ width: '100rem' }">
        <DataTable resizableColumns columnResizeMode="fit" :value="Crime" tableStyle="min-width: 50rem">
            <Column field="code" header="STT" style="text-align: center">
                <template #body="{ index }">{{ index + 1 }}</template>
            </Column>
            <Column field="cardName" header="Họ tên đối tượng"></Column>
            <Column field="brithDay" header="Năm sinh"></Column>
            <Column field="address" header="Nơi ĐKTT">
                <template #body="{ data }">{{ getAddress(data) }}</template>
            </Column>
            <Column field="parentnames" header="Họ tên bố/mẹ"></Column>
            <Column field="criminalCharges" header="Tội danh"></Column>
            <Column field="decisionDay" header="Số ngày QĐ"></Column>
            <Column field="decisionUnit" header="Đơn vị ra QĐ"></Column>
        </DataTable>
        <template #footer>
            <div class="flex justify-content-end gap-2">
                <Button type="button" label="Bỏ qua" severity="secondary" @click="visibleCrime = false"></Button>
            </div>
        </template>
    </Dialog>
    <Loading v-if="isLoading"></Loading>
</template>
<script setup>
import API from '@/api/api-main';
import dialogCustomer from '@/components/Customer.vue';
import { showAmlWarning } from '@/helper/amlDaily';
import { transaction } from '@/stores/transaction';
import axios from 'axios';
import { concat } from 'lodash';
import { useToast } from 'primevue/usetoast';
import { onBeforeMount, ref, watch } from 'vue';

const Transaction = transaction();
const toast = useToast();
const isLoading = ref(false);
const Customers = ref([]);
const uptCustomerModal = ref(false);
const visibleCrime = ref(false);
const Crime = ref([]);
const dataPage = ref({
    page: 1,
    pagesize: 30,
    max: false
});
const fnT = Transaction.$state;

onBeforeMount(() => {
    document.addEventListener('keydown', function (event) {
        if (event.key === 'F4') {
            event.preventDefault();
            fnT.data[fnT.active].Customer = '';
            setTimeout(() => {
                document.getElementById('searchCustomer').querySelector('input').focus();
                document.getElementById('searchCustomer').querySelector('input').select();
            }, 100);
        }
    });
});

const search = async (e) => {
    if (isLoading.value) return;
    isLoading.value = true;
    dataPage.value.page = 1;
    dataPage.value.max = false;
    try {
        const [cccd] = e.query.trim().split('|');
        const { data } = await API.get(`Customer/GetAll?Page=${dataPage.value.page}&PageSize=${dataPage.value.pagesize}&search=${cccd}`);
        if (data?.items?.data?.length) {
            if (data?.items?.data?.length === 1) {
                fnT.data[fnT.active].Customer = data?.items?.data[0];
                getCrime(data?.items?.data[0]);
            } else {
                Customers.value = data?.items?.data;
            }
        } else {
            if (!(await taxCode(e.query.trim()))) await GetBarCodeCustom(e.query.trim());
        }
    } catch (e) {
        console.error(e);
    } finally {
        isLoading.value = false;
    }
};

const taxCode = async (code) => {
    try {
        const res = await axios.get(`https://api.vietqr.io/v2/business/${code}`);

        if (res.data?.code == '00') {
            let { address, name, id } = res.data.data;
            address = address.toLowerCase().replace('việt nam', '');
            address = address.replace(/,\s*$/, '');

            const city = await searchAddress(address.split(',')[address.split(',').length - 1]);

            const area = await searchAddress(address.split(',')[address.split(',').length - 2], city);

            const location = await searchAddress(address.split(',')[address.split(',').length - 3], area);

            address = address.replace(address.split(',')[address.split(',').length - 1], '');

            address = address.replace(address.split(',')[address.split(',').length - 2], '');

            address = address.replace(address.split(',')[address.split(',').length - 3], '');

            address = address.replace(/,+$/, '');

            fnT.data[fnT.active].Customer = {
                series: '',
                bpCode: '',
                cardName: capitalizeWords(name) || '',
                type: 'C',
                groupCode: '',
                licTradNum: id,
                citizenId: '',
                avatar: '',
                gender: '',
                dateOfBirth: null,
                address: capitalizeWords(address) || '',
                location: location || '',
                locationId: location?.id || '',
                locationName: location?.name || '',
                area: area || '',
                areaId: area?.id || '',
                areaName: area?.name || '',
                city: city || '',
                cityId: city?.id || '',
                cityName: city?.name || '',
                email: '',
                phone: '',
                person: '',
                note: '',
                status: 'HD',
                creator: '',
                isEmployee: false,
                employeeId: '',
                crD1: [],
                dshTs: []
            };

            addNewCustomerDialog();
            return true;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

const getUserLazy = async (key) => {
    if (dataPage.value.max) return;
    if (isLoading.value) return;
    isLoading.value = true;
    dataPage.value.page += 1;
    try {
        const { data } = await API.get(`Customer/GetAll?Page=${dataPage.value.page}&PageSize=${dataPage.value.pagesize}&search=${key}`);
        if (!data?.items?.data.length) {
            dataPage.value.max = true;
        }
        Customers.value = concat(Customers.value, data?.items?.data);
    } catch (error) {
    } finally {
        setTimeout(() => {
            isLoading.value = false;
        }, 500);
    }
};

const Remove = () => {
    if (fnT.data[fnT.active].payload.id) {
        Transaction.CLEAR_DATA(fnT.active, fnT.data[fnT.active].id);
        return;
    }
    fnT.data[fnT.active].Customer = '';
    fnT.data[fnT.active].payload.cardId = 0;
    fnT.data[fnT.active].payload.cardCode = '';
    fnT.data[fnT.active].payload.cardName = '';
};

const openUpdVendorDialog = async (id) => {
    const { data } = await API.get(`Customer/${id}`);
    fnT.data[fnT.active].Customer = data;
    uptCustomerModal.value = true;
};

const addNewCustomerDialog = () => {
    uptCustomerModal.value = true;
};

const searchAddress = async (e, dataAdd = null) => {
    if (dataAdd === '') return {};
    try {
        if (dataAdd) {
            const { data } = await API.get(`Area/searchs/${dataAdd.id}/${e.trim()}`);
            return data[0];
        }
        const { data } = await API.get(`Area/searchs/${e.trim()}`);
        return data[0];
    } catch (error) {
        return {};
    }
};

const GetBarCodeCustom = async (key) => {
    const [cccd, cmnd, name, dob, gender, address, date] = key.split('|').map((item) => item?.trim() ?? '');

    if (cccd.length < 12) return;

    // QR ghi ngày dạng ddmmyyyy
    const parseDate = (s) => (s?.length === 8 ? new Date(s.substring(4, 8), s.substring(2, 4) - 1, s.substring(0, 2)) : '');

    const dateOfBirt = parseDate(dob);

    const addressParts = (address || '').split(',').map((item) => item?.trim() ?? '');

    const city = addressParts[addressParts.length - 1] ? await searchAddress(addressParts[addressParts.length - 1]) : '';

    const area = addressParts[addressParts.length - 2] ? await searchAddress(addressParts[addressParts.length - 2], city) : '';

    const location = addressParts[addressParts.length - 3] ? await searchAddress(addressParts[addressParts.length - 3], area) : '';

    fnT.data[fnT.active].Customer = {
        series: '',
        bpCode: '',
        cardName: capitalizeWords(name) || '',
        type: 'P',
        groupCode: '',
        licTradNum: '',
        citizenId: cccd || '',
        avatar: '',
        gender: gender?.toLowerCase() === 'nam' ? 'M' : 'F',
        dateOfBirth: dateOfBirt,
        typeDoc: 100,
        issueDate: parseDate(date),
        address: capitalizeWords(addressParts[0]) || '',
        // location: location || '',
        // locationId: location?.id || '',
        locationName: addressParts[addressParts.length - 3] || '',
        // area: area || '',
        // areaId: area?.id || '',
        areaName: addressParts[addressParts.length - 2] || '',
        // city: city || '',
        // cityId: city?.id || '',
        cityName: addressParts[addressParts.length - 1] || '',
        email: '',
        phone: '',
        person: '',
        note: '',
        status: 'HD',
        creator: '',
        isEmployee: false,
        employeeId: '',
        crD1: [],
        dshTs: []
    };

    addNewCustomerDialog();
};

const capitalizeWords = (string) => {
    if (!string) return ''; // Kiểm tra chuỗi rỗng hoặc null
    return string
        .split(' ') // Tách chuỗi thành mảng từ
        .map((word) => capitalizeFirstLetter(word)) // Áp dụng hàm capitalizeFirstLetter cho từng từ
        .join(' '); // Ghép lại thành chuỗi
};

const capitalizeFirstLetter = (string) => {
    if (!string) return ''; // Kiểm tra chuỗi rỗng hoặc null
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

const updateCustome = (data) => {
    fnT.data[fnT.active].Customer = data;
};

const getAddress = (data) => {
    if (!data) return '';
    return `${data.address || ''} ${checkNull(data.address)} ${data.locationName || ''} ${checkNull(data.locationName)} ${data.areaName || ''} ${checkNull(data.cityName)} ${data.cityName || ''}`;
};
const checkNull = (data) => {
    return data ? ',' : '';
};

const closeDialogCustomer = (e) => {
    uptCustomerModal.value = false;
    // Nhả chốt để lần lưu phiếu sau có thể mở lại popup
    fnT.customerDialogClaimed = false;
    if (typeof fnT.data[fnT.active].Customer === 'string') {
        fnT.data[fnT.active].Customer = '';
    }
};

watch(
    () => fnT.data[fnT.active].Customer,
    () => {
        if (fnT.data[fnT.active].Customer.id == undefined) return;
        Transaction.SET_CUSTOMER();
        // Cảnh báo rửa tiền hiện ngay lúc ra thông tin khách, không đợi tới lúc lưu/in phiếu.
        showAmlWarning(fnT.data[fnT.active]);
        showBirthdayWarning(fnT.data[fnT.active]);
    }
);

// Ticket 678: chỉ mảng vàng trang sức.
const JEWELRY_TYPES = ['HOA_DON_VTS', 'DAT_HANG_VTS', 'DOI_TRA_HANG_VTS', 'MUA_HANG_VTS'];

// Mỗi tab một instance SearchCustomer nên watch bắn N lần cùng lúc — chỉ chặn bản trùng trong 2 giây.
// Không chặn hẳn theo mã khách: nhập lại đúng khách đó (không reload trang) vẫn phải báo.
const showBirthdayWarning = (tab) => {
    const { cardCode, cardName, dateOfBirth } = tab.payload;
    if (!JEWELRY_TYPES.includes(tab.type) || !dateOfBirth) return;
    if (tab.birthdayWarned === cardCode && Date.now() - tab.birthdayWarnedAt < 2000) return;
    const dob = new Date(dateOfBirth);
    if (dob.getMonth() !== new Date().getMonth()) return;
    tab.birthdayWarned = cardCode;
    tab.birthdayWarnedAt = Date.now();
    // group 'center': Toast riêng giữa màn hình ở SalePage, góc phải khó thấy.
    toast.add({ group: 'center', severity: 'warn', summary: 'Khách hàng có sinh nhật trong tháng', detail: `${cardName || cardCode} — sinh ngày ${dob.getDate()}/${dob.getMonth() + 1}`, life: 10000 });
};

// Khi gate validate khách hàng yêu cầu cập nhật (lúc lưu phiếu), mở popup khách hàng.
// Có nhiều instance SearchCustomer (mỗi tab 1 cái) nên dùng cờ customerDialogClaimed
// để chỉ instance đầu tiên mở popup, tránh bật lên 2 lần.
watch(
    () => fnT.openCustomerEditNonce,
    () => {
        if (!fnT.data[fnT.active].payload.cardId) return;
        if (fnT.customerDialogClaimed) return;
        fnT.customerDialogClaimed = true;
        uptCustomerModal.value = true;
    }
);

const getCrime = async (key) => {
    try {
        const cardName = key?.cardName;
        let brithDay = key?.dateOfBirth || '';
        if (brithDay) {
            brithDay = ',brithDay=' + brithDay.split('-')[0];
        }
        const { data } = await API.get(`Crime?Page=1&PageSize=100000&Filter=(cardName=*${cardName}${brithDay})`);
        if (data.items.length) {
            Crime.value = data.items;
            visibleCrime.value = true;
        }
    } catch (error) {
        Crime.value = [];
    }
};

const Fnscroll = () => {
    setTimeout(() => {
        const el = document.querySelector('.p-autocomplete-panel');
        if (el) {
            el.addEventListener('scroll', function () {
                const element = this;
                if (element.scrollHeight - element.scrollTop === element.clientHeight) {
                    if (typeof fnT.data[fnT.active].Customer == 'string') {
                        getUserLazy(fnT.data[fnT.active].Customer);
                    }
                }
            });
        }
    }, 500);
};
</script>
<style scoped>
.box-upload-img {
    border: 1px solid;
    border-radius: 50%;
    border-style: dashed;
}

.box-upload-img:hover .btn-up-file {
    display: block;
}

.input_number::-webkit-outer-spin-button,
.input_number::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
.input_number[type='number'] {
    -moz-appearance: textfield;
}
</style>
